// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmallAccountMenuButton-cls1___29bfb68a6e24f180d7b{/*!*/}.SmallAccountMenuButton-cls2___ccac9b7e6a3ab8c3941{background:transparent;border:none;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SmallAccountMenuButton-cls1___29bfb68a6e24f180d7b",
	"cls2": "SmallAccountMenuButton-cls2___ccac9b7e6a3ab8c3941 SmallAccountMenuButton-cls1___29bfb68a6e24f180d7b"
};
export default ___CSS_LOADER_EXPORT___;
